export default "__VITE_ASSET__d04c6b93__"